// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3B37n","vLegacy":"SelectSecondary_vLegacy__3HWtK","error":"SelectSecondary_error__1Xv4j","disabled":"SelectSecondary_disabled__3aeR4"};